import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      alias: ['/login'],
      name: 'login',
      meta: { loginRequired: false, auth: 'all' },
      component: () => import('@/components/Login')
    },
    {
      path: '*',
      redirect: '/notfound',
      meta: { off: true, auth: 'all' }
    },
    {
      path: '/notfound',
      meta: { off: true, auth: 'all' },
      name: 'NotFound',
      props: { type: 'not-found' },
      component: () => import('@/components/Error')
    },
    {
      path: '/error/server',
      meta: { off: true, auth: 'all' },
      name: 'ServerError',
      props: { type: 'server-error' },
      component: () => import('@/components/Error')
    },
    {
      path: '/privacy',
      name: 'Privacy',
      meta: { off: true, auth: 'all' },
      component: () => import('@/components/PrivacyAgree')
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      meta: { loginRequired: true, auth: ['user', 'company', 'admin'] },
      component: () => import('@/components/Main'),
      children: [
        {
          name: 'DashboardStatus',
          path: '/dashboard',
          component: () => import('@/components/dashboard/Dashboard')
        }
      ]
    },
    {
      path: '/realtime/:link',
      name: 'realtime',
      meta: { loginRequired: true, auth: ['user', 'company'] },
      component: () => import('@/components/Main'),
      children: [
        {
          name: 'MainMap',
          path: '/realtime/map',
          component: () => import('@/components/realtime/Map')
        },
        {
          path: '/realtime/event',
          component: () => import('@/components/realtime/Event'),
          children: [
            {
              name: 'EventBoard',
              path: '/realtime/event',
              component: () => import('@/components/realtime/EventComponents/EventBoard')
            },
            {
              name: 'EventViewer',
              path: '/realtime/event/view',
              component: () => import('@/components/realtime/EventComponents/EventViewer')
            }
          ]
        },
        {
          path: '/realtime/temperature',
          component: () => import('@/components/realtime/Temperature'),
          children: [
            {
              name: 'TemperatureBoard',
              path: '/realtime/temperature',
              component: () => import('@/components/realtime/TemperatureComponents/TemperatureBoard')
            },
            {
              name: 'TemperatureViewer',
              path: '/realtime/temperature/view',
              component: () => import('@/components/realtime/TemperatureComponents/TemperatureViewer')
            }
          ]
        },
        {
          path: '/realtime/*',
          redirect: '/error'
        }
      ]
    },
    {
      path: '/carmanage/:link',
      name: 'carmanage',
      meta: { loginRequired: true },
      component: () => import('@/components/Main'),
      children: [
        {
          path: '/carmanage/car',
          component: () => import('@/components/carmanage/Car'),
          meta: { auth: ['user', 'company'] },
          children: [
            {
              name: 'CarBoard',
              path: '/carmanage/car',
              component: () => import('@/components/carmanage/CarComponents/CarBoard')
            },
            {
              name: 'CarViewer',
              path: '/carmanage/car/view',
              component: () => import('@/components/carmanage/CarComponents/CarViewer')
            },
            {
              name: 'CarRegister',
              path: '/carmanage/car/register',
              component: () => import('@/components/carmanage/CarComponents/CarRegister')
            },
            {
              name: 'CarModify',
              path: '/carmanage/car/modify',
              component: () => import('@/components/carmanage/CarComponents/CarModify')
            },
          ]
        },
        {
          path: '/carmanage/model',
          component: () => import('@/components/carmanage/Model'),
          children: [
            {
              name: 'ModelBoard',
              path: '/carmanage/model',
              meta: { auth: 'all' },
              component: () => import('@/components/carmanage/ModelComponents/ModelBoard')
            },
            {
              name: 'ModelViewer',
              path: '/carmanage/model/view',
              meta: { auth: 'all' },
              component: () => import('@/components/carmanage/ModelComponents/ModelViewer')
            },
            {
              name: 'ModelRegister',
              path: '/carmanage/model/register',
              meta: { auth: ['admin'] },
              component: () => import('@/components/carmanage/ModelComponents/ModelRegister')
            },
            {
              name: 'ModelModify',
              path: '/carmanage/model/modify',
              meta: { auth: ['admin'] },
              component: () => import('@/components/carmanage/ModelComponents/ModelModify')
            },
          ]
        },
        {
          path: '/carmanage/*',
          redirect: '/error'
        }
      ]
    },
    {
      path: '/routemanage/:link',
      name: 'routemanage',
      meta: { loginRequired: true, auth: ['user', 'company'] },
      component: () => import('@/components/Main'),
      children: [
        {
          path: '/routemanage/route',
          component: () => import('@/components/routemanage/Route'),
          children: [
            {
              name: 'RouteBoard',
              path: '/routemanage/route',
              component: () => import('@/components/routemanage/RouteComponents/RouteBoard')
            },
            {
              name: 'RouteViewer',
              path: '/routemanage/route/view',
              component: () => import('@/components/routemanage/RouteComponents/RouteViewer')
            },
            {
              name: 'RouteRegister',
              path: '/routemanage/route/register',
              meta: { mobile: false },
              component: () => import('@/components/routemanage/RouteComponents/RouteRegister')
            }
          ]
        },
        {
          path: '/routemanage/dispatch',
          component: () => import('@/components/routemanage/Dispatch'),
          children: [
            {
              name: 'DispatchBoard',
              path: '/routemanage/dispatch',
              component: () => import('@/components/routemanage/DispatchComponents/DispatchBoard')
            }
          ]
        },
        {
          path: '/routemanage/*',
          redirect: '/error'
        }
      ]
    },
    {
      path: '/drivemanage/:link',
      name: 'drivemanage',
      meta: { loginRequired: true, auth: ['user', 'company'] },
      component: () => import('@/components/Main'),
      children: [
        {
          path: '/drivemanage/drive',
          component: () => import('@/components/drivemanage/Drive'),
          children: [
            {
              name: 'DriveBoard',
              path: '/drivemanage/drive',
              component: () => import('@/components/drivemanage/DriveComponents/DriveBoard')
            },
            {
              name: 'DriveViewer',
              path: '/drivemanage/drive/view',
              component: () => import('@/components/drivemanage/DriveComponents/DriveViewer')
            }
          ]
        },
        {
          path: '/drivemanage/charge',
          component: () => import('@/components/drivemanage/Charge'),
          children: [
            {
              name: 'ChargeBoard',
              path: '/drivemanage/charge',
              component: () => import('@/components/drivemanage/ChargeComponents/ChargeBoard')
            },
            {
              name: 'ChargeViewer',
              path: '/drivemanage/charge/view',
              component: () => import('@/components/drivemanage/ChargeComponents/ChargeViewer')
            }
          ]
        },
        {
          path: '/drivemanage/driver',
          component: () => import('@/components/drivemanage/Driver'),
          children: [
            {
              name: 'DriverBoard',
              path: '/drivemanage/driver',
              component: () => import('@/components/drivemanage/DriverComponents/DriverBoard')
            },
            {
              name: 'DriverViewer',
              path: '/drivemanage/driver/view',
              component: () => import('@/components/drivemanage/DriverComponents/DriverViewer')
            },
            {
              name: 'DriverRegister',
              path: '/drivemanage/driver/register',
              component: () => import('@/components/drivemanage/DriverComponents/DriverRegister')
            },
            {
              name: 'DriverModify',
              path: '/drivemanage/driver/modify',
              component: () => import('@/components/drivemanage/DriverComponents/DriverModify')
            }
          ]

        },
        {
          path: '/drivemanage/*',
          redirect: '/error'
        }
      ]
    },
    {
      path: '/config/:link',
      name: 'config',
      meta: { loginRequired: true },
      component: () => import('@/components/Main'),
      children: [
        {
          name: 'ConfigMypage',
          path: '/config/mypage',
          meta: { auth: ['user', 'company'] },
          component: () => import('@/components/config/Mypage')
        },
        {
          name: 'ConfigSystem',
          path: '/config/system',
          meta: { auth: ['company'] },
          component: () => import('@/components/config/System')
        },
        {
          name: 'ConfigMangeAccount',
          path: '/config/account',
          meta: { auth: ['company'] },
          component: () => import('@/components/config/ManageAccount')
        },
        {
          name: 'ConfigCompany',
          path: '/config/company',
          meta: { auth: ['admin'] },
          component: () => import('@/components/config/Company'),
          children: [
            {
              name: 'ConfigCompanyBoard',
              path: '/config/company',
              meta: { auth: ['admin'] },
              component: () => import('@/components/config/CompanyComponents/CompanyBoard')
            },
            {
              name: 'ConfigCompanyViewer',
              path: '/config/company/view',
              meta: { auth: ['admin'] },
              component: () => import('@/components/config/CompanyComponents/CompanyViewer')
            },
            {
              name: 'ConfigCompanyModify',
              path: '/config/company/modify',
              meta: { auth: ['admin'] },
              component: () => import('@/components/config/CompanyComponents/CompanyModify')
            },
            {
              name: 'ConfigCompanyRegister',
              path: '/config/company/register',
              meta: { auth: ['admin'] },
              component: () => import('@/components/config/CompanyComponents/CompanyRegister')
            }
          ]
        },
        {
          name: 'ConfigHistory',
          path: '/config/history',
          meta: { auth: ['admin'] },
          component: () => import('@/components/config/History')
        },
        {
          path: '/config/*',
          redirect: '/error'
        }
      ]
    },
    {
      path: '/app/:link',
      name: 'app',
      meta: { app: true, loginRequired: true },
      component: () => import('@/components/App'),
      children: [
        {
          name: 'AppViewRoute',
          path: '/app/view_route',
          component: () => import('@/components/app/ViewRoute')
        },
        {
          path: '/app/:link',
          redirect: '/error'
        }
      ]
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

// router guard
router.beforeEach(async (to, from, next) => {
  // offline available
  if (to.matched.some(info => info.meta.off === true)) {
    next()
    return
  }
  else {
    // need network
    // 계정 권한 확인
    if (to.matched.some(info => info.meta.app === true))
      appRouter(to, from, next)
    else
      webRouter(to, from, next);
  }
})

// app
async function appRouter(to, _, next, stack = 0) {
  // await axios.post('/ebms/app/login/employee', { group_name: '삼영운수', ei_number: 353890 })

  const result = await axios.get('/api/auth')
    .then(res => res.data)
    .catch(err => {
      return {
        code: -1,
        err: err
      }
    })

  // server error checker
  if (result.code === -1) {
    if (stack > 3)
      router.push({ name: 'ServerError' })
    else
      setTimeout(() => appRouter(to, _, next, ++stack), 1000);
    return
  }

  // mobile app session check
  if (result.data.app !== 1) {
    // window.alert('세션 오류')
    // await axios.get('/api/destroy')
    // next({ name: 'notfound' })
    // return;
  }

  next()
}

// web
async function webRouter(to, _, next, stack = 0) {
  const result = await axios.get('/api/auth')
    .then(res => res.data)
    .catch(err => {
      return {
        code: -1,
        err: err
      }
    })

  // server error checker
  if (result.code === -1) {
    if (stack > 3)
      router.push({ name: 'ServerError' })
    else
      setTimeout(() => webRouter(to, _, next, ++stack), 1000);
    return
  }

  let status;
  if (result.code === 1) {
    status = result.data
  }
  else if (result.code === 0) {
    console.log('Server connection error')
  }

  // mobile app session check
  if (result.data.app !== undefined && result.data.app !== 'all') {
    window.alert('Invalid access.')
    await axios.get('/api/destroy')
    next({ name: 'login' })
    return;
  }

  // only login users
  if (to.matched.some(routeInfo => routeInfo.meta.loginRequired === true)) {
    // session check
    if (status.auth === true) {
      // auth check
      const authority = checkAuthority(to, status)
      if (!authority) {
        window.alert('You do not have permission to access this page.')
        router.replace(0);
      }
      else if (checkMobileWeb(to)) {
        window.alert('This page is not accessible on mobile.')
        router.replace(0);
      }
      else {
        next({ params: { user_name: status.name } });
      }
    }
    else {
      window.alert('Session has expired.');
      next({ name: 'login' })
    }
  }
  // only not login users
  else if (to.matched.some(routeInfo => routeInfo.meta.loginRequired === false)) {
    if (status.auth === true) {
      const authority = checkAuthority(to, status)
      if (!authority) {
        window.alert('You do not have permission to access this page.')
        router.go(-1);
      }
      else if (checkMobileWeb(to)) {
        window.alert('This page is not accessible on mobile.')
        router.replace(0);
      }
      else {
        if (status.authority == 'admin')
          next({ name: 'ConfigCompany' });
        else
          next({ name: 'MainMap' });
      }
    }
    else
      next()
  }
  // all users
  else {
    const authority = checkAuthority(to, status)
    if (!authority) {
      window.alert('You do not have permission to access this page.')
      router.go(-1);
    }
    else
      next();
  }
}

function checkAuthority(to, status) {
  return to.matched.some(routeInfo => {
    const auth = routeInfo.meta.auth;
    if (Array.isArray(auth))
      return auth != null ? auth.some(info => info === status.authority) : false
    else if (auth === 'all')
      return true
    else
      return false
  })
}

function checkMobileWeb(to) {
  if (window.innerWidth > 1280) return false
  else return to.matched.some(routeInfo => routeInfo.meta.mobile === false)
}

export default router
